export const TESTER_APPLICATION_ENDPOINT = '/api/submit-tester-application';

function randomHexDigit() {
  if (window.crypto?.getRandomValues) {
    const values = new Uint8Array(1);
    window.crypto.getRandomValues(values);
    return values[0] & 0x0f;
  }

  return Math.floor(Math.random() * 16);
}

export function createSubmissionId() {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const value = randomHexDigit();
    const digit = character === 'x' ? value : ((value & 0x3) | 0x8);
    return digit.toString(16);
  });
}

export function createFormSession(now = Date.now()) {
  return {
    formStartedAt: now,
    submissionId: createSubmissionId()
  };
}

export function buildTesterApplicationPayload(formData, session) {
  return {
    name: formData.get('name'),
    email: formData.get('email'),
    location: formData.get('location'),
    occupation: formData.get('occupation'),
    system: formData.get('system'),
    workflow: formData.get('workflow'),
    why: formData.get('why'),
    needs: formData.get('needs'),
    availability: formData.get('availability'),
    agreementTasks: formData.has('agreementTasks'),
    agreementPreAlpha: formData.has('agreementPreAlpha'),
    agreementConfidentiality: formData.has('agreementConfidentiality'),
    website: formData.get('website') || '',
    formStartedAt: session.formStartedAt,
    submissionId: session.submissionId
  };
}

export async function submitTesterApplication(payload, fetchImplementation = window.fetch) {
  if (typeof fetchImplementation !== 'function') {
    throw new Error('Application submission is unavailable in this browser.');
  }

  const response = await fetchImplementation(TESTER_APPLICATION_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  let responseBody = {};
  try {
    responseBody = await response.json();
  } catch {
    responseBody = {};
  }

  if (!response.ok) {
    const error = new Error(
      responseBody.error || 'We could not submit your application right now. Please try again.'
    );
    error.status = response.status;
    error.fieldErrors = responseBody.fieldErrors || {};
    throw error;
  }

  return responseBody;
}
